import { Card } from "@/components/Card";
import Shimmer from "@/components/Shimmer";
import { HeaderTextBlock } from "@/components/Typography";
import { getAppConfig } from "@/utils/appManager";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Support = () => {
  const { t } = useTranslation();
  const [isFormLoaded, setIsFormLoaded] = useState<boolean>(false);

  const { hubsportPortalId, hubsportFormId } = getAppConfig();
  const formTargetId = "hubspotSupportForm";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      // @ts-expect-error
      if (window.hbspt) {
        setIsFormLoaded(true);

        // @ts-expect-error
        window.hbspt.forms.create({
          region: "na1",
          portalId: hubsportPortalId,
          formId: hubsportFormId,
          target: "#" + formTargetId,
        });
      }
    });
  }, []);

  if (!isFormLoaded) {
    return <Shimmer height="570px" rounded="sm" />;
  }

  const renderHeaderTextBlock = () => (
    <div className="mb-20">
      <HeaderTextBlock
        align="left"
        featureTextColor="primary"
        headingTextColor="secondary"
        featureText={t("support.header.feature")}
        headingText={t("support.header.heading")}
        descriptionText={t("support.header.description")}
      />
    </div>
  );

  const renderForm = () => (
    <Card rounded="md" shadow>
      <div className="p-20" id={formTargetId}></div>
    </Card>
  );

  return (
    <div className="flex flex-col gap-10">
      {renderHeaderTextBlock()}
      {renderForm()}
    </div>
  );
};

export default Support;
